module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Modern Visiniu1.d1287c32.jpg";